import { z } from "zod";

// ADV-799: Today page "Follow-ups needed" section data shape.
//
// A unified row over two sources today: overdue invoices and stale
// opportunities. The discriminator is `source` — the URL builder + UI use it
// to pick the destination link and the displayed date label
// (due_date vs stale_since). Adding a third source (e.g. failed comm
// deliveries) is a new variant of the discriminated union.

const InvoiceFollowUpSchema = z.object({
  source: z.literal("invoice").describe("Source"),
  id: z.string().uuid().describe("ID"),
  label: z.string().describe("Label"),
  secondary: z.string().nullable().describe("Secondary"),
  due_date: z.string().describe("Due Date"),
  amount: z.number().nullable().describe("Amount"),
});

const OpportunityFollowUpSchema = z.object({
  source: z.literal("opportunity").describe("Source"),
  id: z.string().uuid().describe("ID"),
  label: z.string().describe("Label"),
  secondary: z.string().nullable().describe("Secondary"),
  stale_since: z.string().describe("Stale Since"),
  amount: z.number().nullable().describe("Amount"),
});

export const FollowUpRowSchema = z.discriminatedUnion("source", [
  InvoiceFollowUpSchema,
  OpportunityFollowUpSchema,
]);
export type FollowUpRow = z.infer<typeof FollowUpRowSchema>;
